import type { FeatureFlagName } from '@/client/types/AuthConfig';
import { useAuthStore } from '@/client/services/state/authStore';

// TODO: Use this hook everywhere a flag check is needed instead of importing authConfig.

export const useCheckFeatureFlag = (featureFlag: FeatureFlagName): boolean => {
  const { authConfig } = useAuthStore();
  const { company } = authConfig;
  const { feature_flags: featureFlags } = company;

  // Local dev override: run `localStorage.setItem('ff_override_enable_workshops_migration', 'true')` in console
  // NOTE: use process.env.NODE_ENV (Vite-replaced, jest-safe) rather than
  // import.meta.env — the latter is a syntax error under the ts-jest/CommonJS
  // setup, which would break any test that renders a component using this hook.
  if (process.env.NODE_ENV !== 'production') {
    const override = localStorage.getItem(`ff_override_${featureFlag}`);
    if (override !== null) return override === 'true';
  }

  return featureFlags[featureFlag] ?? false;
};
